module.exports = __webpack_public_path__ + "static/media/loadingspin.a8ce444d.svg";